module.exports = __webpack_public_path__ + "assets/b33bf44c5a39e7cee6766b33c4450e79.mp3";